import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function LightbulbSolidBoltGroupIcon(props) {
	return (
		<IconBase type="lightbulb-solid-bolt-group" {...props}>
			<path d="M7 21C7 21.55 7.45 22 8 22H12C12.55 22 13 21.55 13 21V20H7V21Z" />
			<path
				clipRule="evenodd"
				d="M10 2C6.14 2 3 5.14 3 9C3 11.38 4.19 13.47 6 14.74V17C6 17.55 6.45 18 7 18H13C13.55 18 14 17.55 14 17V14.74C15.81 13.47 17 11.38 17 9C17 5.14 13.86 2 10 2ZM10 10H7.5L10 5V8.0303H12.5L10 13V10Z"
				fillRule="evenodd"
			/>
			<path d="M17 18H15.8287C15.9396 17.6871 16 17.3505 16 17V14.74C17.8322 13.0967 19 11.6733 19 9C19 6.33492 17.8371 3.93759 15.9918 2.28856C18.8845 3.14846 21 5.83169 21 9C21 11.38 19.81 13.47 18 14.74V17C18 17.55 17.55 18 17 18Z" />
			<path d="M16 22H14.8287C14.9396 21.6871 15 21.3505 15 21V20H17V21C17 21.55 16.55 22 16 22Z" />
		</IconBase>
	);
}

LightbulbSolidBoltGroupIcon.propTypes = iconPropTypes;
